<template>
  <AbaDownload :titulo="titulo" v-if="!loading">
    <div style="width: 360px" v-if="!ocorreuErro">
      <CardDownload
        v-if="objetoArquivo.nomeArquivo"
        :nomeArquivo="objetoArquivo.nomeArquivo"
      />

      <div style="text-align: center" class="titulo negrito my-auto" v-else>
        NENHUM ARQUIVO ENCONTRADO
      </div>

      <unicom-botao
        @click="baixar"
        nomeIcone="download-cloud"
        :largura="360"
        style="margin-top: 72px"
      >
        BAIXAR
      </unicom-botao>
    </div>
    <div class="titulo negrito my-auto" v-else>NENHUM ARQUIVO ENCONTRADO</div>
  </AbaDownload>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaDownloadMixin from "../AbaDownloadMixin";

export default {
  mixins: [AbasMixin, AbaDownloadMixin],
  data() {
    let objetoArquivo = {
      nomeArquivo: ""
    };

    return {
      loading: false,
      objetoArquivo,
      ocorreuErro: false
    };
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      this.inicializarArquivo();
    },
    inicializarArquivo() {
      this.loading = true;
      this.sleep(250).finally(() => {
        this.getPrestadoresIndisponiveisAoIntercambio(this.filtroComputed)
          .then(res => {
            const { nomeArquivo } = res.data;

            this.objetoArquivo = { nomeArquivo };
          })
          .catch(() => {
            this.ocorreuErro = true;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    baixar() {
      this.$store.commit("setLoadingModal", true);

      this.getDownloadPrestadoresIndisponiveisAoIntercambio(this.filtroComputed)
        .then(res => {
          if (res.status === 204) return;
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"]
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    }
  },
  computed: {
    filtroComputed() {
      const { competencia } = this.objetoFiltro;

      return { competencia };
    },
    textoSubtitulo() {
      const { competencia } = this.objetoFiltro;

      if (!competencia) return "";

      return `${this.$helpers.formatadorData(competencia, "MMMM [de] YYYY")}.`;
    }
  }
};
</script>

<style lang="scss" scoped>
.container-vertical {
  display: flex;
  justify-content: center;
}
</style>
